import { Navigate, Outlet } from "react-router-dom";
import { Login } from "../pages/Login/Login";
import JobApplicationPage from "../pages/JobApplication/JobApplicationPage";
import Layout from "../components/Layout/Layout";
import { Suspense } from "react";
import LoadingPanel from "../components/sys-toolbox/LoadingPanel";

const App = () => {
  return (
    <Layout>
      <Suspense fallback={LoadingPanel}>
        <Outlet />
      </Suspense>
    </Layout>
  );
};
export const publicRoutes = [
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <JobApplicationPage />,
      },
      {
        path: "/login",
        element: <Login />,
      },
      { path: "*", element: <Navigate to="/login" /> },
    ],
  },
];
